import css from 'styled-jsx/css'
import { colors, grids } from '../../styles'
import { transparentize } from '../../utils/colors'
import columns from '../../utils/columns'

// styled-jsx blows up if you put these inline like a sensible person
const cols5 = columns({ cols: 5 })

const cols8 = columns({ cols: 8 })

const cols4med = columns({
  cols: 4,
  grid: 'medium',
})

const cols6med = columns({
  cols: 6,
  grid: 'medium',
})

const just1colhuge = columns({
  cols: 1,
  grid: 'superWide',
  totalCols: 1,
})

export default css`
.CardRefresh {
  display: block;
  margin-bottom: 16px;
  margin-right: 16px;
  position: relative;
  width: ${cols5};
  min-width: ${cols5}; /* IE11 needs min-width as well as width */
  z-index: 1;
  transition: 400ms z-index;
  transition-delay: 0;
  cursor: pointer;
}

.CardRefresh.categories {
  margin-bottom: 0;
  margin-right: 0;
  flex: 1;
  width: unset;
  min-width: 163.5px;
}

.CardRefresh.live, .CardRefresh.continue-watching {
  margin-right: ${grids.wide.gutter}px;
  min-width: 300px;
  width: 300px;
}
.ps-overlay{
  position: absolute;
  z-index: 9;
  top: 68%;
  right: 8px;
  padding: 4px;
  border-radius: 50%;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.ps-overlay.programme {
  top: unset;
  bottom: 6%;
  right: 3.3%;
}
.ps-overlay.episode {
  top: 6%;
  bottom: auto;
  right: 3.3%;
}
.ps-overlay.poster {
  right: unset;
  left: 3.3%;
  top: 1.5%;
}

figure .ps-logo-overlay{
  position: absolute;
  z-index: 9;
  top: 10px;
  right: 10px;
  border-radius: 0px;
  display: flex;
  gap: 8px;
  flex-direction: row;
  align-items: center;
}

.ps-logo {
    display: block;
    height: 50px;
    width: 50px;
    border-radius: 50px;
    overflow: hidden;
}

.sponsor{
  position: absolute;
  top: 10px;
  right: 1%;
}
.CardRefresh:not(.specialEvent) :global(img) {
  box-shadow: 0px 1px 3px 1px rgba(0, 0, 0, 0.15);
  filter: drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.3));
}

.CardRefresh.categories:first-of-type {
  margin: 0;
}

.CardRefresh.special-event {
  width: 100%;
  min-width: 100%;
}

.CardRefresh.large {
  width: ${cols8};
  min-width: ${cols8};
}

.CardRefresh.stacking{
  display: flex;
  width: 100%;
  margin-left: ${grids.narrow.margin}px;
}

.CardRefresh.specialEvent {
  width: ${just1colhuge};
  max-width: 1920px;
  margin: 0px;

}
.cardSummary{
  -webkit-line-clamp: 5;
  line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-top: 8px;
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  display: -webkit-box;
  color: #C4C4C4;
}
.cardAvailable{
  padding-top: 8px;
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  display: flex;
  align-items: center;
  color: #9E9E9E;
}
.dateSummary{
  padding-left: 3px;
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  display: flex;
  align-items: center;
  color: #9E9E9E;
}
.cardTitle{
  padding-top: 8px;
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 25px;
  color: #F6F6F6;
  text-overflow: ellipsis;
  white-space: normal;
}
.cardDuration{
  padding-top: 8px;
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 25px;
  display: flex;
  align-items: center;
  color: #F6F6F6;
  flex-shrink: 0;
  white-space: nowrap;
}

.overlay-icon {
  margin: 4px 0 4px 8px;
}

.cardWrap{
  display: flex;
  flex-direction: row;
  padding-top: 10px;
  gap: 6px;
}

.iconWrap{
  padding-top: 8px;
  display: flex;
  align-items: center;
}

.CardRefresh.sponsorship-card {
  margin-left: 0;
}

a, a:visited {
  color: inherit;
}

a:hover, a:focus {
  color: ${colors.textHoverPurple};
}

a::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: block;
  z-index: 2;
}


.svod-exclusive-label {
  position: fixed;
  top: 4px;
  left: 4px;
}

.force-ads-warning {
  position: fixed;
  top: 4px;
  left: 4px;
  filter: drop-shadow(0px 1px 2px #000000) drop-shadow(0px 1px 3px #000000);
}
.progress-bar {
  left: 7px;
  bottom: 4px;
  width: 93%;
  position: absolute;
  height: 4px;
  flex-shrink: 0;

  filter: drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.30)) drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.15));
}

.progress-bar.live, .progress-bar.cont-watch {
  bottom: 8px;
  left: 16px;
  right: 16px;
  width: auto;
}

span {
  content: '';
  position: absolute;
  top: 0;
  bottom: -10px;
  left: 0;
  right: 0;
  display: block;
  z-index: 2;
  background: linear-gradient(190deg, #151515 0%, rgba(21, 21, 21, 0) 45%), linear-gradient(0deg, #151515 0%, rgba(21, 21, 21, 0) 0%);
}

figure {
  margin: 0 0 0px;
  position: relative;
  transition: 100ms transform;
  transform-origin: center;
  transform: scale(1.00000001); /* avoid child elements flickering when transform starts */
  backface-visibility: hidden;
  will-change: transform;
  border-radius: 8px;
  overflow: hidden;
}

.hero-cta-wrapper {
  position: absolute;
  bottom: 40px;
  left: 16px;
  z-index: 1000;
  max-width: 527px;
}
.hero-cta-wrapper-program{
  position: absolute;
  padding-top: 24%;
  bottom: 42%;
  left: 16px;
  z-index: 1000;
  max-width: 527px;
}

.hero-cta-wrapper.animationend{
  animation-fill-mode: forwards;
  animation-delay: 10ms;
  animation: dissolve;
  animation-timing-function: ease-out;
  animation-duration: 800ms;
}

@-webkit-keyframes dissolve {
  100% {
    transform: transform: translateX(0);}
  0% {
    transform: translateX(100%);}
}
@keyframes dissolve {
  100% {
    transform: transform: translateX(0);}
  0% {
    transform: translateX(100%); }
}

.faded figure{
  opacity: 0.5;
}

.stacking figure{
  max-width: 108px;
  margin-right: 16px;
}

figcaption {
  position: absolute;
  left: 0;
  background: ${transparentize(colors.IconButtonPurple, 0.8)};
  padding: 4px 8px;
  bottom: 0;
  border-radius: 0px 0px 0px 8px;
}

figure .live-gradient, figure .progress-gradient {
  z-index: 1;
  position: absolute;
  top: 0;
  bottom: 0px;
  left: 0;
  right: 0;
  display: flex;
  color: ${transparentize(colors.primaryText, 0.8)};
  background: linear-gradient(180deg,rgba(0.13,0.13,0.13,0.00) 0%,rgba(0.13,0.13,0.13,0.36) 64%,rgba(0.13,0.13,0.13,1.0) 100%);
  border-radius: 8px;
  border: 1px solid ${transparentize(colors.primaryText, 0.1)};
  background-origin: border-box;
}

figure .figure-overlay.live {
  bottom: 50%;
  top: 35%;
  left: 0;
  width: 100%;
  z-index: 1;
}

figure .figure-overlay.continue-watching {
  z-index: 1;
}

figcaption.live {
  color: ${colors.primaryText};
  display: flex;
  background: ${colors.liveRed};
  top: 12px;
  left: 16px;
  bottom: unset;
  border-radius: 4px;
  padding: 2px 4px 2px 4px;
}

figcaption.live p.live-subtitle {
  padding-left: 4px;
  display: inline-block;
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 1.6px;
  text-transform: uppercase;
}

figure .live-info, figure .duration.cont-watch, figure .figure-overlay-cw .duration {
  position: absolute;
  bottom: 12px;
  left: 16px;
  z-index: 2;
  padding-bottom: 2px;
}

.CardRefresh.live figure .live-info p {
 color: rgba(246, 246, 246, 0.80);
 text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.30), 0px 1px 3px rgba(0, 0, 0, 0.15);
}

.CardRefresh.live figure .live-info p.live-title {
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
}

.live-info {
  max-width: 75%;
}

p.live-title {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.CardRefresh.live figure .live-info p.live-time, figure .duration.cont-watch, figure .figure-overlay-cw .duration {
  font-size: 12px;
  font-weight: 400;
  line-height: normal;
}

.figure-overlay-program{
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  flex-direction: column;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0;
  z-index: 2;
}
.recom-prog{
  display :flex;
  flex-direction: row;
  gap: 6px;
  position: absolute;
  bottom: 8px;
  color: ${colors.white};
  left: 7px;
  width: 93%;
  font-size: 20px;
}
.numEpisode{
  display: flex;
  gap: 6px;
  align-items: center;
}
.figure-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 4px;
  bottom: 4px;
  transform: scale(1.00001); /* avoid child elements flickering when transform starts */  
}

.duration.cont-watch{
  position: absolute;
  bottom: 8px;
  color: ${colors.white};
  left: 7px;
  width: 93%;

  /* Elevation Dark */
  text-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.30), 0px 1px 3px 1px rgba(0, 0, 0, 0.15);
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.duration {
  position: absolute;
  bottom: 8px;
  color: ${colors.white};
  left: 7px;
  width: 93%;

  text-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.30), 0px 1px 3px 1px rgba(0, 0, 0, 0.15);
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.progress {
  height: 5px;
  margin-bottom: 16px;
  margin-top: -5px;
  z-index: 1;
  position: relative;
  border-radius: 8px;
}

.card-text {
  padding-right: 2rem;
  padding-top: 5px;
}

.categories .card-text {
  padding-top: 8px;
}

.CardRefresh .HoverOverlay{
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  background: linear-gradient(180deg, rgba(21, 21, 21, 0.75) 0%, ${colors.baseBg});
  text-align: bottom;
  overflow: hidden;
  opacity: 0;
  height: 100%;
  transition: opacity 300ms ease-in-out;
  transition-delay: 150ms;
}

.CardRefresh .HoverOverlay.poster {
  background: linear-gradient(179.62deg, rgba(21, 21, 21, 0) 32%, rgba(21, 21, 21, 0.9) 61%);
  transition: 400ms ease-in-out;
  border-radius: 8px;
}

.CardRefresh .HoverOverlay.poster.sports {
  background: linear-gradient(180.25deg, rgba(0, 0, 0, 0.5) 0.21%, #000000 98%);
}

.CardRefresh.poster.sports figure:after {
  content: '';
  width: 100%;
  height: 100%;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0) 65.97%, rgba(0, 0, 0, 0.411476) 78.99%, rgba(0, 0, 0, 0.72) 98.03%);
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 1;
}

.ps-overlay p.programme-detail {
  display: none;
  font-size: 18px;
  font-weight: 600;
  line-height: 22px;
  color: #FFFF00;
  text-transform: capitalize;
}

.HoverOverlay .content {
  position: absolute;
  bottom: 0;
  margin: 16px;
  width: calc(100% - 32px);
}

.HoverOverlay.large .content,
.HoverOverlay.poster .content  {
  margin: 16px 16px 32px 16px;
  border-radius: 8px;
}

.HoverOverlay .title {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  margin-bottom: 0;
}

.HoverOverlay .subtitle {
  color: ${colors.textHoverPurple};
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  margin-bottom: 5px;
}

.HoverOverlay .description-container {
  display: flex;
  gap: 10%;
  align-items: end;

}

.HoverOverlay .description-inner-container {
  width: 100%;

}

.HoverOverlay .playButton {
  height: 42px;
  width: 42px;
}

.HoverOverlay .description {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
}

.HoverOverlay.truncate-desc .description {
  -webkit-line-clamp: 2;
}

.HoverOverlay a {
  position: relative;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: block;
  z-index: 2;
  font-size: 0;
  line-height: 0;
}

.CardRefresh .HoverOverlay .border {
  background: ${colors.textHoverPurple};
  width: 100%;
  padding-top: 4px;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  display: block;
  transition: transform 300ms ease;
  transition-delay: 100ms;
  transform: scaleX(0);
  transform-origin: right;
}
.CardRefresh.tabCard {
  width: 300px;
  min-width: 300px !important;
}
.CardRefresh.tabCard figure {
  border: 2px solid transparent;
}
.CardRefresh.tabCard :first-child{
  margin-left: 0px !important;
}
.CardRefresh.recom-card {
  width: 264px;
  min-width: 264px !important;
}
.CardRefresh.recom-card figure {
  margin-bottom: 2px;
}

.CardRefresh.large .HoverOverlay .border {
  padding-top: 6px;
}

.CardRefresh.specialEvent figure {
  transform: none;
}

@media (hover: hover) {
  .CardRefresh:hover {
    border-radius: 8px;
  }

  .CardRefresh:not(.specialEvent):hover {
    z-index: 2;
  }

  .CardRefresh:not(.specialEvent):hover figure {
    transform: scale(1.055) !important;
    transform: translateZ(0);
    backface-visibility: hidden;
    -webkit-font-smoothing: subpixel-antialiased;
    box-shadow: 0px 0px 8px #fff; // white shadow
  }

  .CardRefresh.episode:hover figure {
    transform: scale(1.06)
    transform: translateZ(0);
    backface-visibility: hidden;
    -webkit-font-smoothing: subpixel-antialiased;
  }
  .CardRefresh.tabCard:hover figure {
    border: 2px solid rgba(246, 246, 246, 0.5);
    box-shadow: 0px 0px 8px #fff;
    transform: none !important;
    margin-bottom: 0px;
  }
  .CardRefresh.recom-card:hover figure {
    border: 2px solid rgba(246, 246, 246, 0.5);
    box-shadow: 0px 0px 8px #fff;
    transform: none !important;
    margin-bottom: 0px;
  }

  .CardRefresh.poster.sports:hover figure:after {
    transition: opacity 0.3s ease-out;
    opacity: 0;
  }

  .CardRefresh.no-scale:hover figure {
    transform: none !important;
  }
  a:hover .figure-overlay-program{
    opacity: 1;
  }

  .CardRefresh:hover figure .ps-overlay p.programme-detail {
    display: block;
  }
}

:global(.ie) .CardRefresh:hover {
  z-index: 2;
}

:global(.ie) .CardRefresh:hover figure {
  backface-visibility: hidden;
  transform: translateZ(0);
  -webkit-font-smoothing: subpixel-antialiased;
  transform: scale(1.055);
}

:global(.ie) .CardRefresh.no-scale:hover figure {
  transform: none !important;
}

@media (min-width: 767px) {
.hero-cta-wrapper-program{
  bottom: 30%!important;
  left: 24px;
}
.CardRefresh.specialEvent figure {
  min-height: 500px;
  transform: none;
}
.CardRefresh.programHead figure {
  min-height: auto;
  transform: none;
}
span {
  bottom: -5px;
}
.CardRefresh:hover .figure-overlay-program.recom {
  opacity: 1;
  background: linear-gradient(179.62deg, rgba(21, 21, 21, 0) 62%, rgba(21, 21, 21, 0.9) 91%);
}
}
@media (max-width: 767px) {
  .CardRefresh.tabCard {
    width: 300px;
    min-width: 300px !important;
  }
  .hero-cta-wrapper {
    position:fixed;
    padding-left: 8px;
    padding-right: 8px;
    left: 0px;
    width: 100%;
    max-width: 100%;
    z-index: 10000;
  }
  .hero-cta-wrapper-program{
    position:relative;
    padding-left: 16px;
    padding-right: 16px;
    margin-top: -230px;
    left: 0px;
    width: 100%;
    max-width: 100%;
    z-index: 10000;
  }
  .CardRefresh.specialEvent{
    height: auto;
  }
  .CardRefresh.specialEvent figure {
    min-height: 420px;
  }
  .CardRefresh.programHead figure span {
    bottom: 110px !important;
  }
  span {
    bottom: -50px;
    left: 0%;
    background: linear-gradient(0deg, #151515 15.1%, rgba(21, 21, 21, 0.4) 45.4%, rgba(21, 21, 21, 0.1) 100%);
  }
}

@media (max-width: 1023px) {
  .HoverOverlay {
    display: none;
  }
}

@media (min-width: 1024px) {
  .CardRefresh.specialEvent{
    height: auto !important;
  }
  .hero-cta-wrapper {
  }
  .hero-cta-wrapper-program{
    bottom: 45% !important;
    left: 24px;
  }
  .CardRefresh.categories {
    min-width: 287px;
  }
}

@media (min-width: 1200px) {
  .hero-cta-wrapper {
    left: 16px;
    z-index: 1000;
  }
  .hero-cta-wrapper-program{
    position: absolute;
    bottom: 45% !important;
    left: 48px;
    z-index: 1000;
  }
  span{
    bottom: -10px !important;
  }
}

@media (min-width: 1920px) {
  .hero-cta-wrapper {
    padding-top: 30%;
  }
  .hero-cta-wrapper-program{
    padding-top: 30%;
    left: 48px;
  }
}

@media (min-width: ${grids.medium.breakpoint}px) {
  @media (hover: hover) {
    .CardRefresh:hover .HoverOverlay  {
      opacity: 1;
      transition: opacity 300ms ease-in-out;
    }
    .CardRefresh:hover .HoverOverlay .border {
      transform: scaleX(1);
      transform-origin: center;
    }
  }
  .CardRefresh, .CardRefresh.stacking {
    width: ${cols4med};
    min-width: ${cols4med};
    display: block;
  }

  .CardRefresh.large {
    width: ${cols6med};
    min-width: ${cols6med};
  }

  .CardRefresh.wrapping:nth-of-type(3n+1){
    margin-left: ${grids.medium.margin}px;
  }

  .CardRefresh:not(.specialEvent):last-of-type {
    margin-right: ${grids.medium.margin}px;
  }

  .CardRefresh.categories:last-of-type, .CardRefresh.categories:first-of-type {
    margin-right: 0;
    margin-left: 0;
  }

  .stacking figure{
    max-width: none;
    margin-right: auto;
  }

  .figure-overlay {
    bottom: 16px;
    right: 16px;
    z-index: 5;
  }

  :global(.CardRefresh .TriangleRightIcon) {
    width: 40px !important;
    height: 40px !important;
  }
}

@media (min-width: ${grids.wide.breakpoint}px) {
  .CardRefresh, .CardRefresh.stacking{
    margin-right: ${grids.wide.gutter}px;
    min-width: 300px;
    width: 260px;
  }

  .CardRefresh.special-event {
    width: 100%;
    min-width: 100%;
  }

  .CardRefresh.large {
    width: 400px;
    min-width: 400px;
  }
  .CardRefresh.tabCard {
    width: 300px;
    min-width: 300px !important;
  }

  .CardRefresh.wrapping:nth-of-type(3n+1){
    margin-left: 0;
  }
  .CardRefresh.wrapping:nth-of-type(4n+1){
    margin-left: ${grids.wide.margin}px;
  }
  .CardRefresh:not(.specialEvent):last-of-type {
    margin-right: ${grids.wide.margin}px;
  }

  .CardRefresh.categories:last-of-type, .CardRefresh.categories:first-of-type {
    margin-right: 0;
    margin-left: 0;
  }
}

@media (min-width: 450px) {
  figure .figure-overlay.live {
    top: 50%;
  }
}
`
